import Cookies from 'js-cookie';

require('devextreme/ui/data_grid');

// Make selected griddata globally available
var selectedDatagridData;
window.selectedDatagridData = selectedDatagridData;

// settings for project and employee datagrid
var enableDatagridSelection = {
    selection: {
        mode: "multiple"
    }
};
window.enableDatagridSelection = enableDatagridSelection;

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var pagesize = parseInt(getCookie("pagesize"));

// Default settings for datagrid
var defaultDatagridOptions = {
    searchPanel: {
        visible: true,
        width: 240,
        placeholder: "Zoeken"
    },
    paging: {
        pageSize: pagesize
    }, 
    pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [5, 10, 20, 50, 100],
        showInfo: true
    },
    showBorders: true,
    // selection: {
    //     mode: "multiple"
    // },
    sorting: {
        mode: "multiple"
    },
    onOptionChanged: function(e){
        if(e.fullName == 'paging.pageSize'){
            e.enabled = true;
            document.cookie = "pagesize=" + e.value;
        }
    },
    onSelectionChanged: function(selectedItems) {
        let data = [];
        window.selectedDatagridData = selectedItems.selectedRowsData;
        data = window.selectedDatagridData;

        if ($('#navbarOnSelection').length) {
            if (data.length > 0) {
                $("#navbarDefault").hide();
                $("#navbarOnSelection").show();
            } else {
                $("#navbarDefault").show();
                $("#navbarOnSelection").hide();
            }
        }
    }
};
window.defaultDatagridOptions = defaultDatagridOptions;

// Checkbox to toggle inactive datagrid items
function toggleVisibilityDatafield(dataGrid, dataField, defaultValue, label, value = false, cookie = null) {
    $("#filterVisible").dxCheckBox({
        value: value,
        text: label,
        onValueChanged: function (e) {
            if (!e.value) {
                // Hide deactivated items if checkbox is false
                dataGrid.filter([dataField, "=", defaultValue]);
                if (cookie) {
                    Cookies.set(cookie, 1);
                }
            } else {
                dataGrid.clearFilter();
                if (cookie) {
                    Cookies.set(cookie, 0);
                }
            }
        }
    });
}
window.toggleVisibilityDatafield = toggleVisibilityDatafield;

// Show button template used in datagrid
function showButton(container, options, request) {
    $('<div>')
        .append($('<a class="btn btn-link" data-toggle="tooltip" title="Details" ' +
            'href="/' + request + '/show/' + options.value + '">' +
            '<i class="fas fa-search-plus"></i></a>'))
        .appendTo(container);
}
window.showButton = showButton;

// Edit button template used in datagrid
function editButton(container, options, request) {
    $('<div>')
        .append($('<a class="btn btn-link" data-toggle="tooltip" title="Wijzigen" ' +
            'href="/' + request + '/edit/' + options.value + '">' +
            '<i class="fas fa-pencil-alt"></i></a>'))
        .appendTo(container);
}
window.editButton = editButton;

// Remove button template used in datagrid
function removeButton(container, options, request, title) {
    title = (typeof title !== 'undefined') ?  title : options.data.name;

    $('<div class="tooltip-container" data-toggle="tooltip" title="Verwijderen">')
        .append('<button class="btn btn-link btn-link-danger" data-toggle="modal" ' +
                    'data-target="#deleteModal" data-id="' + options.data.id + '" ' +
                    'data-title="' + title + '" ' +
                    'data-url="/' + request + '/delete/' + options.data.id + '">' +
                        '<i class="fas fa-times"></i></button>')
        .appendTo(container);
}
window.removeButton = removeButton;

// Deactivate button template used in datagrid
function deactivateButton(container, options, request, title) {
    title = (typeof title !== 'undefined') ?  title : options.data.name;

    $('<div class="tooltip-container" data-toggle="tooltip" title="Deactiveren">')
        .append('<button class="btn btn-link btn-link-danger" data-toggle="modal" ' +
                    'data-target="#deactivateModal" data-id="' + options.data.id + '" ' +
                    'data-title="' + title + '" ' +
                    'data-url="/' + request + '/deactivate/' + options.data.id + '">' +
                        '<i class="fas fa-eye-slash"></i></button>')
        .appendTo(container);
}
window.deactivateButton = deactivateButton;

// Activate button template used in datagrid
function activateButton(container, options, request, title) {
    title = (typeof title !== 'undefined') ?  title : options.data.name;

    $('<div class="tooltip-container" data-toggle="tooltip" title="Activeren">')
        .append('<button class="btn btn-link" data-toggle="modal" ' +
                    'data-target="#activateModal" data-id="' + options.data.id + '" ' +
                    'data-title="' + title + '" ' +
                    'data-url="/' + request + '/activate/' + options.data.id + '">' +
                        '<i class="fas fa-eye"></i></button>')
        .appendTo(container);
}
window.activateButton = activateButton;



// WEBPACK FOOTER //
// ./resources/js/components/datagrid.js